import React, {Component} from 'react';
import {SwatchesPicker} from 'react-color';
import './color-picker.css';

export default class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPicker: false,
      color: 'blue'
    }
    this.toggleVisible = this.toggleVisible.bind(this);
    this.handleChangeComplete = this.handleChangeComplete.bind(this);
  }
  toggleVisible() {
    this.setState({showPicker: !this.state.showPicker});
  }
  handleChangeComplete(color) {
    this.setState({
      color: color.hex,
      showPicker: false
    });
    if(this.props.onChange) {
      this.props.onChange(color.hex);
    }
  }
  render() {
    if(this.state.showPicker)
      return (<SwatchesPicker onChangeComplete={this.handleChangeComplete} />);
    else
      return (
        <div className="color-picker" onClick={this.toggleVisible}>
          <div style={{backgroundColor: this.state.color}}/>
        </div>
      )
  }
}



// WEBPACK FOOTER //
// ./src/components/color-picker/color-picker.js